import React, { useRef, useEffect } from "react";
import { Link } from "gatsby";
import kebabCase from "lodash.kebabcase";
import { useMeasure } from "react-use";

export const DesktopKnowHowLinks = ({
  data,
  activeInnerMenu,
  setActiveInnerMenu,
  setActiveMenuHeight,
}) => {
  const [ref, { height }] = useMeasure();

  // Report the expanded menu height to the parent. Must run in an effect —
  // calling the parent setter during render triggers a React setState-in-render
  // warning.
  useEffect(() => {
    setActiveMenuHeight(height + (activeInnerMenu + 1) * 50);
  }, [height, activeInnerMenu, setActiveMenuHeight]);

  const knowhowLinks = data
    // Keep flat links that have a resolved page, and any subpage group.
    .filter(
      (link) =>
        link.slice_type === "menu_item_with_subpages" ||
        link.primary.page?.document != null
    )
    .map((link, index) => {
      // Flat link (menu_item): behaves like the previous Know-How menu.
      if (link.slice_type !== "menu_item_with_subpages") {
        return (
          <li
            key={`single_knowhow_section_${index}`}
            className="classico single-link-section"
          >
            <Link to={`${link.primary.page.url}`}>
              {link.primary.page.document.data.title.text}
            </Link>
          </li>
        );
      }

      // Group with sub-pages (menu_item_with_subpages): title + hover-expand list.
      const handleEnter = () => {
        if (activeInnerMenu !== index) setActiveInnerMenu(index);
      };

      const sectionLinks = link.items
        .filter((innerLink) => innerLink.link?.document != null)
        .map((innerLink) => (
          <li key={`single_link_${index}_${innerLink.link.document.id}`}>
            <Link to={innerLink.link.url}>
              {innerLink.link.document.data.title.text}
            </Link>
          </li>
        ));

      return (
        <li
          key={`single_knowhow_section_${index}`}
          className={`classico single-link-section ${
            activeInnerMenu === index ? `active` : ``
          } section-${kebabCase(link.primary.title.text)}`}
        >
          <div className="title">
            {/* Group headers may have no page set (they only expand their
                sub-pages on hover), so fall back to a non-navigating label. */}
            {link.primary.page?.url ? (
              <Link to={`${link.primary.page.url}`} onMouseEnter={handleEnter}>
                {link.primary.title.text}
              </Link>
            ) : (
              <span onMouseEnter={handleEnter}>{link.primary.title.text}</span>
            )}

            {sectionLinks.length >= 1 && <div className="line" />}
          </div>

          <div className={`links`}>
            {activeInnerMenu === index && <ol ref={ref}>{sectionLinks}</ol>}
          </div>
        </li>
      );
    });

  return knowhowLinks;
};
